<template>
    <div v-if="form_id">
        <b-modal
            v-model="showModalLocal"
            :title="'Код для размещения формы на сайте'"
            class="modal-primary"
            size="lg"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
<!--            <div class="row">-->
<!--                <div class="col col-12 col-md-6">-->
<!--                    <b-form-group-->
<!--                        label="Город"-->
<!--                        description="Начальное значение города для формы."-->
<!--                    >-->
<!--                        <v-select-->
<!--                            v-model="params.city_id"-->
<!--                            :options="cities"-->
<!--                            :multiple="true"-->
<!--                            placeholder="Выберите город"-->
<!--                            label="title"-->
<!--                            :reduce="x=>x.id"-->
<!--                        ></v-select>-->
<!--                    </b-form-group>-->
<!--                </div>-->

<!--                <div class="col col-12 col-md-6">-->
<!--                    <b-form-group-->
<!--                        label="Объект размещения"-->
<!--                        description="Начальное значение объекта размещения для формы."-->
<!--                    >-->
<!--                        <v-select-->
<!--                            v-model="params.hotel_id"-->
<!--                            :options="hotels"-->
<!--                            placeholder="Выберите объект"-->
<!--                            :multiple="true"-->
<!--                            label="title"-->
<!--                            :reduce="x=>x.id"-->
<!--                        ></v-select>-->
<!--                    </b-form-group>-->
<!--                </div>-->

<!--                <div class="col col-12 col-md-6">-->
<!--                    <b-form-group-->
<!--                        label="Номер"-->
<!--                        description="Начальное значение номера для формы."-->
<!--                    >-->
<!--                        <v-select-->
<!--                            v-model="params.city_id"-->
<!--                            :options="rooms"-->
<!--                            :multiple="true"-->
<!--                            placeholder="Выберите города"-->
<!--                            label="title"-->
<!--                            :reduce="x=>x.id"-->
<!--                        ></v-select>-->
<!--                    </b-form-group>-->
<!--                </div>-->

<!--                <div class="col col-12 col-md-6">-->
<!--                    <b-form-group-->
<!--                        label="Программы"-->
<!--                        description="Начальное значение программы для формы."-->
<!--                    >-->
<!--                        <v-select-->
<!--                            v-model="params.hotel_id"-->
<!--                            :options="programs"-->
<!--                            placeholder="Выберите программу"-->
<!--                            :multiple="true"-->
<!--                            label="title"-->
<!--                            :reduce="x=>x.id"-->
<!--                        ></v-select>-->
<!--                    </b-form-group>-->
<!--                </div>-->

<!--                <div class="col col-12">-->
<!--                    <b-form-group-->
<!--                        label="UUID"-->
<!--                        description="Уникальная UUID метка для аналитики"-->
<!--                    >-->
<!--                        <div class="input-group">-->
<!--                            <input v-model="params.uuid" class="form-control">-->
<!--                            <button class="btn btn-primary"> сгенерировать</button>-->
<!--                        </div>-->
<!--                    </b-form-group>-->
<!--                </div>-->
<!--            </div>-->

            <b-form-group
                label="имя файла для размещения на своем сайте"
                description="Создате файл с таким именем в корневой папке на своем сайте. "
            >
                <input class="form-control" v-model="orderform_php_file_name"  readonly/>
            </b-form-group>

            <b-form-group
                label="содержимое файла для размещения на своем сайте"
                description="Разместите этот код в созданном файле."
            >
                <textarea class="form-control" v-model="orderform_php_file_code" readonly></textarea>
            </b-form-group>



            <b-form-group
                label="код для вставки"
                description="Вставьте этот код на страницу своего сайта."
            >
                <textarea class="form-control" v-model="orderform_php_insert_code" readonly></textarea>
            </b-form-group>


            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions.js';
    import { orderform_functions } from '@/functions/orderform.js';

    export default {
        name: 'FormCodeDialog',
        mixins: [functions, orderform_functions],
        data: function () {
            return {
                params: {
                    city_id:null,
                    hotel_id:null,
                    room_id:null,
                    program_id:null,
                    uuid:null
                },
                hotel:null,
                rooms:[],
                programs:[],
            };
        },
        model: {
            prop: "form_id",
            event: "hide"
        },
        props: {
            form_id: Number,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", 0);
            },
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return !!this.form_id
                },
                set: function (newValue) {}
            }
        },
        created: function() {
            this.loadOrderForm(this.form_id);

            this.loadHotels();
            this.loadCities();
        },

    }
</script>
